module.exports = __webpack_public_path__ + "static/img/chahua.b24f1cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chahua.png
// module id = QzbA
// module chunks = 1